import useSWR from "swr";
import { simpleFetcher } from "../fetcher";

interface OfficeOnlineUrl {
  officeOnlineUrl: string | null;
}

export function useOfficeOnlineUrl(documentArtifactId?: number) {
  const url = documentArtifactId
    ? `/api/v2/document-artifacts/${documentArtifactId}/office-online-url`
    : null;

  const { data, error, isLoading } = useSWR<OfficeOnlineUrl, Error>(
    url,
    simpleFetcher,
    { revalidateOnFocus: false, revalidateOnMount: true },
  );

  return {
    officeOnlineUrl: data?.officeOnlineUrl ?? null,
    error,
    isLoading,
  };
}
